// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "0d7c853b" + "." + "571c19a96b7a4f57" + ".js";
};